<template>
  <aside>
    <Card>
      <div class="text-center">
        <h3 class="text-uppercase">
          <span class="text-blue">Analyse</span> your site
        </h3>
        <div class="mb-2">
          <img
            width="170"
            class="main-image"
            src="@/assets/url-image.svg"
            alt="URL"
          >
        </div>
      </div>
      <form @submit.prevent="onSubmit">
        <div
          v-if="alert"
          class="alert alert-danger"
        >
          Domain is not valid.
        </div>
        <div class="form-group url-form">
          <label
            for="urlInput"
            class="font-weight-bold"
          >Enter your Domain</label>
          <input
            id="urlInput"
            v-model="domain"
            type="text"
            class="form-control"
            placeholder="Your URL here…"
            @keyup.enter="onSubmit()"
          >
        </div>
        <button
          class="btn btn-lg btn-gradient-primary btn-oval btn-block"
          type="submit"
        >
          START NOW
        </button>
      </form>
    </Card>
  </aside>
</template>
<script>
import Card from '@/components/Card';

export default {
  components: {
    Card
  },

  data() {
    return {
      alert: false,
      domain: 'https://'
    }
  },

  methods: {
    onSubmit() {
      this.alert = false;

      const { domain } = this;

      if(!this.IsDomainValid(domain)) {
        this.alert = true;
        return;
      }
      // TODO: Validate domain
      window.location = `/analyze/${this.formatUrl(domain)}/keywords`;
    }
  }
}
</script>
